// src/stone/icons/AudioVideoPlayCircle.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var AudioVideoPlayCircle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12" }),
      /* @__PURE__ */ jsx("path", { d: "M9.528 7.118a1 1 0 0 1 1.027.05l6 4a1 1 0 0 1 0 1.664l-6 4A1 1 0 0 1 9 16V8a1 1 0 0 1 .528-.882M11 9.868v4.264L14.197 12z" })
    ]
  }
);
var AudioVideoPlayCircle_default = AudioVideoPlayCircle;

export {
  AudioVideoPlayCircle_default
};
